import 'apps/pathways/styles/app/start/headers.scss';
import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import ScrollAnimation from 'library/util/scroll';
import { Link } from 'library/util/core-router';
import { PlayButton } from 'library/components/video';
import ModalHelper from 'library/helpers/modal';
import VideoModal from 'apps/pathways/components/video-modal';
import withConfig from 'util/hoc/with-config';

class HeaderTwo extends React.Component {
  handleScroll = () => {
    const scrollTop = window.scrollY;
    const innerHeight = window.innerHeight;
    const scrollTime = Math.abs((scrollTop - innerHeight) / innerHeight) * 500;
    new ScrollAnimation(scrollTop, innerHeight, scrollTime, 'quad.easeInOut');
  }

  get modal() {
    if (!this._modal) {
      this._modal = new ModalHelper('pathways-video-modal', true, {
        className: 'pathways-video-modal'
      });
    }
    return this._modal;
  }

  closeModal = () => {
    this.modal.element.removeEventListener('click', this.handleModalClick);
    this.modal.unmount();
  }

  handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      this.closeModal();
    }
  }

  openModal = () => {
    this.modal.render(VideoModal, {
      close: this.closeModal,
      video: 'https://assets.pairin.com/videos/pathways-onboarding-survey/playlist-hls.m3u8',
      className: 'pathways-video-modal'
    });
    this.modal.element.addEventListener('click', this.handleModalClick);
  }

  componentWillUnmount() {
    this.closeModal();
  }

  render() {
    const {
      configuration
    } = this.props;

    return (
      <Fragment>
        <h1>
          <small>
            { resolve(configuration, 'apps/pathways/configuration/onboarding_steps/soft-skills/header/sub', 'my')}
          </small>
          { resolve(configuration, 'apps/pathways/configuration/onboarding_steps/soft-skills/header/main', 'soft skills')}
        </h1>
        <div className="pathways-start-header-content">
          <div className="pathways-start-header-video">
            <div className="pathways-start-header-video-video">
              <span className="pathways-start-header-video-placeholder">
                <img src={`https://assets.pairin.com/videos/pathways-onboarding-survey/1280x720-00004_1080.jpg`} />
                <PlayButton onClick={this.openModal} />
              </span>
            </div>
            <div className="pathways-start-header-video-content">
              <p>
                {
                  resolve(
                    configuration,
                    `apps/pathways/configuration/onboarding_steps/soft-skills/description`,
                    `Using PAIRIN’s Science we will calculate your soft skills profile to match you to a career that you will enjoy and thrive in.`
                  )
                }
              </p>
              <button onClick={this.handleScroll}>Get Started</button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withConfig(HeaderTwo);
